var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "001-linkedin",
    clipPath: "url(#clip0_1247_6249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M38 0H6C2.68629 0 0 2.74734 0 6.13636V38.8636C0 42.2527 2.68629 45 6 45H38C41.3137 45 44 42.2527 44 38.8636V6.13636C44 2.74734 41.3137 0 38 0Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8496 12.2727C15.8496 13.0313 15.6297 13.7728 15.2176 14.4035C14.8056 15.0342 14.2199 15.5257 13.5347 15.816C12.8495 16.1063 12.0955 16.1822 11.368 16.0343C10.6406 15.8863 9.97241 15.521 9.44796 14.9846C8.92351 14.4483 8.56636 13.7649 8.42167 13.0209C8.27697 12.277 8.35123 11.5058 8.63506 10.805C8.91889 10.1043 9.39954 9.50527 10.0162 9.08385C10.6329 8.66243 11.3579 8.4375 12.0996 8.4375C13.0942 8.4375 14.048 8.84157 14.7513 9.56081C15.4545 10.2801 15.8496 11.2556 15.8496 12.2727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9995 18.6648V35.6088C15.0001 35.7338 14.9766 35.8577 14.9303 35.9734C14.884 36.089 14.8158 36.1942 14.7296 36.2829C14.6434 36.3715 14.5409 36.4418 14.4281 36.4898C14.3152 36.5378 14.1942 36.5625 14.072 36.5625H10.1195C9.99724 36.5628 9.87615 36.5385 9.76317 36.4908C9.65019 36.4431 9.54754 36.373 9.46111 36.2847C9.37469 36.1963 9.3062 36.0913 9.25958 35.9757C9.21296 35.8602 9.18913 35.7364 9.18946 35.6114V18.6648C9.18946 18.4125 9.28744 18.1706 9.46185 17.9922C9.63626 17.8138 9.87281 17.7136 10.1195 17.7136H14.072C14.3182 17.7143 14.5541 17.8148 14.728 17.9931C14.9018 18.1714 14.9995 18.4129 14.9995 18.6648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.6597 27.4858V35.6881C35.66 35.803 35.6381 35.9168 35.5953 36.0231C35.5524 36.1293 35.4895 36.2259 35.41 36.3071C35.3305 36.3884 35.2362 36.4528 35.1323 36.4966C35.0284 36.5404 34.9171 36.5628 34.8047 36.5625H30.5547C30.4423 36.5628 30.331 36.5404 30.2271 36.4966C30.1232 36.4528 30.0288 36.3884 29.9494 36.3071C29.8699 36.2259 29.807 36.1293 29.7641 36.0231C29.7213 35.9168 29.6994 35.803 29.6997 35.6881V27.7389C29.6997 26.5525 30.0397 22.5435 26.6672 22.5435C24.0547 22.5435 23.5222 25.2869 23.4172 26.5193V35.6881C23.4172 35.9178 23.3289 36.1383 23.1712 36.3019C23.0136 36.4655 22.7993 36.5591 22.5747 36.5625H18.4697C18.3575 36.5625 18.2465 36.5399 18.1429 36.4959C18.0393 36.4519 17.9452 36.3874 17.866 36.3062C17.7868 36.225 17.7241 36.1286 17.6814 36.0225C17.6387 35.9164 17.6169 35.8028 17.6172 35.6881V18.5906C17.6169 18.4759 17.6387 18.3623 17.6814 18.2562C17.7241 18.1501 17.7868 18.0537 17.866 17.9724C17.9452 17.8912 18.0393 17.8268 18.1429 17.7828C18.2465 17.7388 18.3575 17.7162 18.4697 17.7162H22.5747C22.8015 17.7162 23.0189 17.8083 23.1793 17.9723C23.3396 18.1363 23.4297 18.3587 23.4297 18.5906V20.0685C24.3997 18.5804 25.8372 17.4324 28.9047 17.4324C35.6997 17.4324 35.6597 23.9216 35.6597 27.4858Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_6249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinColor);
export default __webpack_public_path__ + "static/media/linkedin-color.24eeae8f3bacf33a3e0dd33d63b0833f.svg";
export { ForwardRef as ReactComponent };